var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonIdealSalebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5599_2920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5 100C78.1142 100 100.5 77.6142 100.5 50C100.5 22.3858 78.1142 0 50.5 0C22.8858 0 0.5 22.3858 0.5 50C0.5 77.6142 22.8858 100 50.5 100Z",
    fill: "#E7EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5 100C78.1142 100 100.5 77.6142 100.5 50C100.5 22.3858 78.1142 0 50.5 0C22.8858 0 0.5 22.3858 0.5 50C0.5 77.6142 22.8858 100 50.5 100Z",
    fill: "url(#paint0_radial_5599_2920)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5899 81.16C84.9065 87.0322 78.9603 91.7737 72.193 95.0325C65.4256 98.2913 58.011 99.9835 50.4999 99.9835C42.9888 99.9835 35.5742 98.2913 28.8069 95.0325C22.0395 91.7737 16.0933 87.0322 11.4099 81.16C12.1699 80.92 7.11991 81 88.4999 81C88.8693 80.9971 89.2369 81.051 89.5899 81.16Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5001 88V95.39C24.4483 93.0449 19.8244 89.8711 15.8201 86H27.5001C28.0305 86 28.5392 86.2107 28.9143 86.5858C29.2894 86.9609 29.5001 87.4696 29.5001 88Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.11 87C83.35 87.7 82.58 88.36 81.78 89H41.5C41.2348 89 40.9804 88.8946 40.7929 88.7071C40.6054 88.5196 40.5 88.2652 40.5 88C40.5 87.7348 40.6054 87.4804 40.7929 87.2929C40.9804 87.1054 41.2348 87 41.5 87H84.11Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.01 93C74.81 93.72 73.57 94.39 72.31 95H41.5C41.2348 95 40.9804 94.8946 40.7929 94.7071C40.6054 94.5196 40.5 94.2652 40.5 94C40.5 93.7348 40.6054 93.4804 40.7929 93.2929C40.9804 93.1054 41.2348 93 41.5 93H76.01Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5 46H12.5C10.2909 46 8.5 47.7909 8.5 50V68C8.5 70.2091 10.2909 72 12.5 72H88.5C90.7092 72 92.5 70.2091 92.5 68V50C92.5 47.7909 90.7092 46 88.5 46Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 51H15.5C14.3954 51 13.5 51.8954 13.5 53V65C13.5 66.1046 14.3954 67 15.5 67H27.5C28.6046 67 29.5 66.1046 29.5 65V53C29.5 51.8954 28.6046 51 27.5 51Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.09 63.4101L18.09 58.4101C17.7624 58.0274 17.5912 57.5353 17.6106 57.0319C17.6301 56.5286 17.8387 56.0511 18.1949 55.6949C18.5511 55.3387 19.0286 55.1301 19.5319 55.1106C20.0353 55.0912 20.5274 55.2624 20.91 55.59L24.5 59.17L31.09 52.59C31.4727 52.2624 31.9648 52.0912 32.4682 52.1106C32.9715 52.1301 33.449 52.3387 33.8052 52.6949C34.1614 53.0511 34.37 53.5286 34.3895 54.0319C34.4089 54.5353 34.2377 55.0274 33.91 55.41L25.91 63.4101C25.5353 63.7826 25.0284 63.9916 24.5 63.9916C23.9717 63.9916 23.4648 63.7826 23.09 63.4101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5 54H41.5C41.2348 54 40.9804 53.8946 40.7929 53.7071C40.6054 53.5196 40.5 53.2652 40.5 53C40.5 52.7348 40.6054 52.4804 40.7929 52.2929C40.9804 52.1054 41.2348 52 41.5 52H86.5C86.7652 52 87.0196 52.1054 87.2071 52.2929C87.3946 52.4804 87.5 52.7348 87.5 53C87.5 53.2652 87.3946 53.5196 87.2071 53.7071C87.0196 53.8946 86.7652 54 86.5 54Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5 60H41.5C41.2348 60 40.9804 59.8946 40.7929 59.7071C40.6054 59.5196 40.5 59.2652 40.5 59C40.5 58.7348 40.6054 58.4804 40.7929 58.2929C40.9804 58.1054 41.2348 58 41.5 58H86.5C86.7652 58 87.0196 58.1054 87.2071 58.2929C87.3946 58.4804 87.5 58.7348 87.5 59C87.5 59.2652 87.3946 59.5196 87.2071 59.7071C87.0196 59.8946 86.7652 60 86.5 60Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5 66H41.5C41.2348 66 40.9804 65.8946 40.7929 65.7071C40.6054 65.5196 40.5 65.2652 40.5 65C40.5 64.7348 40.6054 64.4804 40.7929 64.2929C40.9804 64.1054 41.2348 64 41.5 64H63.5C63.7652 64 64.0196 64.1054 64.2071 64.2929C64.3946 64.4804 64.5 64.7348 64.5 65C64.5 65.2652 64.3946 65.5196 64.2071 65.7071C64.0196 65.8946 63.7652 66 63.5 66Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5 15H12.5C10.2909 15 8.5 16.7909 8.5 19V37C8.5 39.2091 10.2909 41 12.5 41H88.5C90.7092 41 92.5 39.2091 92.5 37V19C92.5 16.7909 90.7092 15 88.5 15Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5 11H12.5C10.2909 11 8.5 12.7909 8.5 15V33C8.5 35.2091 10.2909 37 12.5 37H88.5C90.7092 37 92.5 35.2091 92.5 33V15C92.5 12.7909 90.7092 11 88.5 11Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 16H15.5C14.3954 16 13.5 16.8954 13.5 18V30C13.5 31.1046 14.3954 32 15.5 32H27.5C28.6046 32 29.5 31.1046 29.5 30V18C29.5 16.8954 28.6046 16 27.5 16Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.09 28.41L18.09 23.41C17.7624 23.0274 17.5912 22.5353 17.6106 22.0319C17.6301 21.5286 17.8387 21.0511 18.1949 20.6949C18.5511 20.3387 19.0286 20.1301 19.5319 20.1106C20.0353 20.0912 20.5274 20.2624 20.91 20.59L24.5 24.17L31.09 17.59C31.4727 17.2624 31.9648 17.0912 32.4682 17.1106C32.9715 17.1301 33.449 17.3387 33.8052 17.6949C34.1614 18.0511 34.37 18.5286 34.3895 19.0319C34.4089 19.5353 34.2377 20.0274 33.91 20.41L25.91 28.41C25.5353 28.7825 25.0284 28.9916 24.5 28.9916C23.9717 28.9916 23.4648 28.7825 23.09 28.41Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5 19H41.5C41.2348 19 40.9804 18.8946 40.7929 18.7071C40.6054 18.5196 40.5 18.2652 40.5 18C40.5 17.7348 40.6054 17.4804 40.7929 17.2929C40.9804 17.1054 41.2348 17 41.5 17H86.5C86.7652 17 87.0196 17.1054 87.2071 17.2929C87.3946 17.4804 87.5 17.7348 87.5 18C87.5 18.2652 87.3946 18.5196 87.2071 18.7071C87.0196 18.8946 86.7652 19 86.5 19Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5 25H41.5C41.2348 25 40.9804 24.8946 40.7929 24.7071C40.6054 24.5196 40.5 24.2652 40.5 24C40.5 23.7348 40.6054 23.4804 40.7929 23.2929C40.9804 23.1054 41.2348 23 41.5 23H86.5C86.7652 23 87.0196 23.1054 87.2071 23.2929C87.3946 23.4804 87.5 23.7348 87.5 24C87.5 24.2652 87.3946 24.5196 87.2071 24.7071C87.0196 24.8946 86.7652 25 86.5 25Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5 31H41.5C41.2348 31 40.9804 30.8946 40.7929 30.7071C40.6054 30.5196 40.5 30.2652 40.5 30C40.5 29.7348 40.6054 29.4804 40.7929 29.2929C40.9804 29.1054 41.2348 29 41.5 29H63.5C63.7652 29 64.0196 29.1054 64.2071 29.2929C64.3946 29.4804 64.5 29.7348 64.5 30C64.5 30.2652 64.3946 30.5196 64.2071 30.7071C64.0196 30.8946 63.7652 31 63.5 31Z",
    fill: "#AEB5BE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5599_2920",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5 8.75) rotate(66.1979) scale(99.7328)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5599_2920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonIdealSalebook);
export default __webpack_public_path__ + "static/media/nonIdealSalebook.9ba2e0c80d77e0a39bb22f4fa50e3857.svg";
export { ForwardRef as ReactComponent };